import "normalize.css";
import "../../css/main.css";
import React from "react";
import ReactDOM from "react-dom/client";
import BaseLayout from "./components/BaseLayout";
import * as assessmentInfo from "./assessmentInfo";
import * as utility from "./utility";
import * as worker from "../baseWorker";

const baseComponentRef = React.createRef<BaseLayout>();
const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
  <BaseLayout ref={baseComponentRef} />
);

// React 18+: createRoot renders asynchronously. Poll for the ref to be populated
// before bootstrapping (a single setTimeout(0) can fire before commit).
function waitForMount(attempt = 0) {
  if (!baseComponentRef.current) {
    if (attempt > 50) {
      console.error("BaseLayout component not mounted yet");
      return;
    }
    setTimeout(() => waitForMount(attempt + 1), 20);
    return;
  }
  const baseComponent = baseComponentRef.current!;

  //display the wait message
  baseComponent.state.showSpinner();
  sessionStorage.clear();
  //Define a function to fetch the user's saved assessments
  async function getSavedAssessments() {
    const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
    let savedAssessments: assessmentInfo.ISavedAssessmentInfo[] = [];

    savedAssessments = await assessmentWorker.listSavedAssessments();
    baseComponent.state.addAssessmentsToList(savedAssessments);
  }
  //get the current user info
  async function getUserInfo() {
    console.log("calling main getUserInfo");
    const userWorker: worker.baseWorker = new worker.baseWorker();
    const currentUser: worker.IUserInfo = await userWorker.getUserInfo();
    baseComponent.state.setCurrentUserInfo(currentUser);
    console.log("exiting main getUserInfo");
  }

  //get current user info
  getUserInfo().then(function () {

    if(baseComponent?.state?.UserInfo?.loggedIn){
      //fetch the list of saved assessments
      getSavedAssessments().then(function () {
        //hide the spinner dialog
        baseComponent.state.hideSpinner();
      })
      .catch(function (error) {
        console.error("An error occurred:", error);
        baseComponent.state.hideSpinner();
      });
    }
    baseComponent.state.hideSpinner();
  })
  .catch(function (error) {
    console.error("An error occurred:", error);
    baseComponent.state.hideSpinner();
  });
}
waitForMount();


